import React from "react";
import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider,
  Typography,
} from "@mui/material";
import classNames from "classnames";
import "./text.scss";

function Text({ withIcon, className, ...props }) {
  let theme = createTheme();
  theme = responsiveFontSizes(theme);

  const classes = classNames(
    "text-wrapper",
    withIcon && withIcon + " flex-text ",
    props.size && "font-" + props.size,
    props.font ? "font-" + props.font : "font-regular",
    props?.breakAll && "break-all",
    className
  );
  return (
    <ThemeProvider theme={theme}>
      <Typography {...props} className={classes}>
        {props.children}
      </Typography>
    </ThemeProvider>
  );
}

export default Text;
